import './style.scss';

const Button = ({title, onCLick}) => {
    return (
        <button className="button" onClick={onCLick}>{title}</button>
    );
}
 
export default Button;